import { createSlice } from '@reduxjs/toolkit';

const appSlice = createSlice({
  name: 'app',
  initialState: {
    isMFE: false,
    mfeHostConfig: {},
  },
  reducers: {
    // Action to set isMFE to a given boolean value
    setIsMFE: (state, action) => {
      state.isMFE = action.payload;
    },
    setMfeHostConfig: (state, action) => {
      state.mfeHostConfig = action.payload;
    },
  },
});

// Export the actions to use in dispatches
export const { setIsMFE, setMfeHostConfig } = appSlice.actions;

// Export the reducer to add to your store
export default appSlice.reducer;
